// firebase.js
import { getStorage } from "firebase/storage";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDfJuyZhzD2tj5yiB_qrEd6U8t2dPLz8fM",
  authDomain: "golden-promos.firebaseapp.com",
  projectId: "golden-promos",
  storageBucket: "golden-promos.firebasestorage.app",
  messagingSenderId: "1043559607577",
  appId: "1:1043559607577:web:31451129bb6dda08c8a988"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);